import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { IonicVue } from '@ionic/vue';
import { addIcons } from 'ionicons';
import { refreshOutline, alertCircle, medical, shieldCheckmark, receiptOutline, cameraOutline, barcodeOutline, arrowDownCircle, arrowUpCircle, walletOutline, informationCircleOutline, checkmarkCircleOutline, shieldCheckmarkOutline, cashOutline, rocketOutline, homeOutline, scanOutline, alertCircleOutline, peopleOutline, personOutline } from 'ionicons/icons';
import '@ionic/vue/css/core.css';
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';
import './theme/variables.css';
import './theme/global.scss';

addIcons({
  refreshOutline, alertCircle, medical, shieldCheckmark, receiptOutline, cameraOutline, barcodeOutline,
  arrowDownCircle, arrowUpCircle, walletOutline, informationCircleOutline, checkmarkCircleOutline,
  shieldCheckmarkOutline, cashOutline, rocketOutline, homeOutline, scanOutline, alertCircleOutline, peopleOutline, personOutline
});

const app = createApp(App)
  .use(IonicVue)
  .use(router);

router.isReady().then(() => {
  app.mount('#app');
});